import Textarea from "@/components/frontend/ui/form/inputs/textarea";
import { type FormTextareaBlock as FormTextareaBlockT } from "@/payload-types";

type FormTextareaBlockProps = FormTextareaBlockT & {
	containerClassName?: string;
	fieldName?: string;
	fieldValue?: unknown;
	fieldError?: string;
	onFieldChange?: (value: unknown) => void;
	onFieldBlur?: () => void;
};

export const FormTextareaBlock: React.FC<FormTextareaBlockProps> = ({
	content,
	settings,
	containerClassName,
	fieldName,
	fieldValue,
	fieldError,
	onFieldChange,
	onFieldBlur,
}) => {
	const minLength = typeof settings?.minLength === "number" ? settings.minLength : undefined;
	const maxLength = typeof settings?.maxLength === "number" ? settings.maxLength : undefined;

	return (
		<Textarea
			name={fieldName}
			value={typeof fieldValue === "string" ? fieldValue : ""}
			onChange={(event) => onFieldChange?.(event.target.value)}
			onBlur={onFieldBlur}
			autoComplete={settings?.autocomplete ?? undefined}
			placeholder={content.placeholder}
			label={content.label}
			hideLabel={settings?.hideLabel ?? undefined}
			description={content.description}
			minLength={minLength}
			maxLength={maxLength}
			error={fieldError}
			required={content.required ?? false}
			containerClassName={containerClassName}
		/>
	);
};
